var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 190,
    viewBox: "0 0 96 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01524 188.714C2.13332 189.534 2.89375 190.103 3.71372 189.985C4.53369 189.867 5.10269 189.106 4.98462 188.286L2.01524 188.714ZM95.7934 9.2593C96.2127 8.54485 95.9735 7.62573 95.2591 7.20638L83.6164 0.37267C82.902 -0.0466795 81.9829 0.192545 81.5635 0.906994C81.1442 1.62144 81.3834 2.54057 82.0978 2.95992L92.4468 9.03432L86.3724 19.3833C85.9531 20.0978 86.1923 21.0169 86.9068 21.4362C87.6212 21.8556 88.5403 21.6164 88.9597 20.9019L95.7934 9.2593ZM4.98462 188.286C0.524151 157.311 4.98641 117.337 19.631 82.7727C34.2764 48.2071 58.9904 19.2922 94.8776 9.95164L94.1219 7.04836C57.0092 16.7078 31.7233 46.5429 16.8687 81.6023C2.01346 116.663 -2.52422 157.189 2.01524 188.714L4.98462 188.286Z",
    fill: "#59EAD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.39dc55b601a8b50c31e05741a8fafce7.svg";
export { ForwardRef as ReactComponent };